import { useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { TextField } from '@mui/material';
import { createClient } from "../api/clients";
import { AuthClient } from '../types';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [message, setMessage] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        setError(null);
        setMessage(null);
        setIsSubmitting(true);

        try {
            const reportClient = createClient(AuthClient);
           
             await reportClient.forgotPassword(email);

                setMessage(
                    'If an account with that email exists, we’ve sent a password reset link.'
                );
            
        } catch (err) {
            console.error(err);
            setError('Something went wrong. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="main pb-4 d-flex flex-column align-items-center">
            <h2 className="mb-3">Reset your password</h2>
           
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                     <p className="mb-4">
                Enter the email address you use for Our Journey and we’ll send you a link to reset your password.
            </p>
                    <TextField
                        fullWidth
                        label="Email address"
                        type="email"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>

                {error && (
                    <p style={{ color: 'red', marginBottom: '1rem' }}>
                        {error}
                    </p>
                )}

                {message && (
                    <p style={{ marginBottom: '1rem' }}>
                        {message}
                    </p>
                )}

                <Button
                    type="submit"
                    className="styled-button"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Sending…' : 'Send reset link'}
                </Button>
            </form>
        </div>
    );
}

export default ForgotPassword;
